function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import _ from 'lodash';
import { getUiOptions, getUiFieldset } from "./";
export const getUiMenu = props => {
  const uiSchema = props.uiSchema,
        registry = props.registry;
  const formContext = registry.formContext;

  if (!formContext) {
    return false;
  }

  const uiLayout = getUiOptions(uiSchema);
  const uiFieldset = getUiFieldset(props);
  const onExpand = formContext.onExpand;
  const currentId = formContext.currentId;
  const nav = uiLayout.nav;

  if (!nav) {
    return false;
  }

  let menu = [];

  if (uiFieldset) {
    uiFieldset.forEach(field => {
      const id = field.id,
            name = field.name,
            uiSchema = field.uiSchema;
      const uiOptions = getUiOptions(uiSchema);
      let selected = false;

      if (currentId && currentId.startsWith(id)) {
        selected = true;
      }

      const title = uiOptions['title'] || name;
      const icon = uiOptions['icon'] || false;
      menu.push(_extends({}, field, {
        selected: selected,
        title: title,
        icon: icon,
        onClick: () => onExpand(field)
      }));
    });
  }

  if (!menu.length) {
    return false;
  }

  const selected = _.find(menu, function (field) {
    return field.selected === true;
  });

  if (menu[0] && !selected) {
    menu[0].selected = true;
  }

  return menu;
};